import request from '@/utils/request'

// 조회
export function getShBudgetProcedure(params, isProgress) {
  return request({
    url: `/api/getShBudgetProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 예시
export function getShBudgetProcedureSample(isProgress) {
  return request({
    url: `/api/getShBudgetProcedureSample`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 삭제
export function saveShBudgetProcedure(params, isProgress) {
  return request({
    url: `/api/saveShBudgetProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 저장
export function deleteShBudgetProcedure(params, isProgress) {
  return request({
    url: `/api/deleteShBudgetProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}
// 출력
export function getShBudgetProcedureReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: '/api/getShBudgetProcedureReport',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}